<template>
	<q-page padding>
		<q-tabs class="shadow-1 q-mt-md" color="secondary" v-model="tab">
			<q-tab slot="title" name="area" :label="$t('areas')" key="tab" />

			<q-tab-pane name="area" key="area">
				<div class="row gutter-md">
					<div class="col-12">
						<q-card class="full-height">
							<q-card-title>
								{{ $t('configure_country_area') }}
							</q-card-title>

							<q-card-separator />

							<q-card-main>
								<draggable :list="areas">
									<q-card
										v-for="(a, index) in areas"
										:key="a.area_id"
										class="cursor-pointer q-mb-md"
									>
										<q-card-main class="row">
											<div class="col-1 self-center">
												<q-icon
													name="fas fa-sort"
													color="primary"
													size="1.75rem"
												/>
											</div>
											<div class="col-10 self-end">
												<p class="text-bold">{{ a.name }}</p>
											</div>
											<div class="col-1">
												<span>
													<q-btn
														flat
														round
														size="1rem"
														color="primary"
														icon="fas fa-pencil-alt"
														@click="changeAreaName(a)"
													>
														<q-tooltip>
															{{ $t('rename') }}
														</q-tooltip>
													</q-btn>
												</span>
											</div>
										</q-card-main>
									</q-card>
								</draggable>
							</q-card-main>
						</q-card>
					</div>
				</div>
			</q-tab-pane>
		</q-tabs>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3 order-last">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="fas fa-chevron-left"
					@click="$router.push({ name: 'admin_overview' })"
				/>
			</div>
		</div>

		<q-modal
			v-model="rename_area"
			v-if="rename_area"
			:content-css="{ minWidth: '60vw', minHeight: '30vh' }"
			no-backdrop-dismiss
			no-esc-dismiss
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="clearNewName()" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('rename_area') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<p>{{ $t('rename') }}</p>
					<q-input v-model="selected_area.name" @keyup.enter.native="saveNewName()" />

					<div class="row justify-end q-mt-lg">
						<div class="row q-mr-sm">
							<q-btn
								color="tertiary"
								:label="$t('cancel')"
								icon="fas fa-times"
								@click="clearNewName()"
							/>
						</div>

						<div class="row">
							<q-btn
								color="positive"
								:label="$t('save')"
								icon="far fa-save"
								@click="saveNewName()"
								:disable="selected_area.name.length === 0"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>
	</q-page>
</template>

<script>
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'

export default {
	name: 'AdminAreasConfig',

	i18nOptions: { namespaces: ['common', 'admin'] },

	data() {
		return {
			tab: 'area',
			areas: [],
			selected_area: null,
			rename_area: false,
			new_area_name: '',
			loaded: false,
		}
	},

	components: {
		draggable,
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},
	},

	methods: {
		fetchAreas() {
			this.$q.loading.show()

			this.$axios
				.get(`/areas/area_countries/`, this.getHeader)
				.then((response) => {
					this.areas = response.data
						? response.data
								.filter(
									(a) =>
										a.status === 1 &&
										a.country === this.id_user_client_country_selected &&
										a.client_id === this.id_user_client_selected
								)
								.sort((a, b) => a.order - b.order)
								.map((a) => ({ ...a, index: a.order }))
						: []
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loaded = true
					this.$q.loading.hide()
				})
		},

		saveConfig() {
			this.$q.loading.show()

			const data = {
				areas_country: this.areas.map((a, index) => ({ ...a, order: index })),
			}

			this.$axios
				.post(`/areas/area_countries/change_areas_order/`, data, this.getHeader)
				.then(() => {
					this.$q.notify({
						message: this.$t('saved_successfully'),
						type: 'positive',
						icon: 'far fa-save',
					})
				})
				.catch((e) => {
					console.log(e)
					this.$q.notify({
						message: this.$t('save_error'),
						type: 'negative',
						icon: 'fas fa-ban',
					})
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		changeAreaName(area) {
			this.selected_area = area
			this.rename_area = true
		},

		saveNewName() {
			this.areas = this.areas.map((a) => ({
				...a,
				name: a.id === this.selected_area.id ? this.selected_area.name : a.name,
			}))
			this.rename_area = false
			this.selected_area = null
		},

		clearNewName() {
			this.rename_area = false
			this.selected_area = null
		},
	},

	created() {
		this.fetchAreas()
	},

	watch: {
		areas: function() {
			if (this.loaded) this.saveConfig()
		},
	},
}
</script>

<style lang="stylus" scoped></style>
